import Icon from 'veui/components/Icon'
import { IconWhirlpool } from 'dls-icons-vue'

Icon.register('whirlpool', IconWhirlpool)
